import { render, staticRenderFns } from "./EditSubCondominium.vue?vue&type=template&id=af80f0a4&scoped=true&"
import script from "./EditSubCondominium.vue?vue&type=script&lang=js&"
export * from "./EditSubCondominium.vue?vue&type=script&lang=js&"
import style0 from "./EditSubCondominium.vue?vue&type=style&index=0&id=af80f0a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af80f0a4",
  null
  
)

export default component.exports